import { useCallback, useEffect, useState } from 'react';
import { getReviewId, getReviewFeatures } from 'query/review';

export function useReviewFeatures(onError?: (error: any) => any) {
  const reviewId = getReviewId() || '';
  const [isLoading, setIsLoading] = useState(true);
  const [features, setFeatures] = useState<string[]>([]);
  const [settings, setSettings] = useState<Record<string, any>>({});

  const hasSelectableMeasures = !!settings?.selectable_measures;
  const useSuggestions = !!settings?.use_suggestions;

  useEffect(() => {
    setIsLoading(true);
    getReviewFeatures(reviewId)
      .then((response) => {
        setFeatures(response.features);
        setSettings(response.settings);
      })
      .catch((error) => {
        if (onError) {
          onError(error);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [reviewId]);

  const hasFeature = useCallback(
    (feature: string) => {
      return features.includes(feature);
    },
    [features]
  );

  const getSetting = useCallback(
    (setting: string) => {
      return settings[setting];
    },
    [settings]
  );

  const canUseSuggestionsForDoi = useCallback(
    (doi: string | null) => {
      return useSuggestions && Boolean(doi);
    },
    [useSuggestions]
  );

  const isStructuredSingleExtractor =
    settings?.['structured_extraction_users_required'] === 1;

  return {
    isLoading,
    hasSelectableMeasures,
    useSuggestions,
    isStructuredSingleExtractor,
    hasFeature,
    getSetting,
    canUseSuggestionsForDoi,
  };
}
